import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { useTrans } from '../../hooks/useTrans';
import { TemperatureGraphDialog } from './TemperatureGraphDialog';

function TemperatureActionButton({ label, glyph, ...props }) {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" aria-label={label} {...props}>
                    <svg role="img" className="fill-current text-[#003545]">
                        <use href={`#${glyph}`}></use>
                    </svg>
                </Button>
            </TooltipTrigger>
            <TooltipContent>{label}</TooltipContent>
        </Tooltip>
    );
}

export function GoodTemperatureActions({ good, traceUuid }) {
    const translate = useTrans();
    const [graphOpen, setGraphOpen] = useState(false);

    if (!good.hasTemperatureReporting || !traceUuid) return null;

    return (
        <TooltipProvider>
            <div className="flex shrink-0 items-center">
                <form method="post" action={`/api/temperature/report/generate/${traceUuid}?good_id=${good.id}`} target="_blank">
                    <TemperatureActionButton type="submit" label={translate('Temperatuurrapportage downloaden')} glyph="glyph-download" />
                </form>
                <TemperatureActionButton
                    type="button"
                    label={translate('Temperatuurverloop bekijken')}
                    glyph="glyph-show-graph"
                    onClick={() => setGraphOpen(true)}
                />
                <TemperatureGraphDialog
                    traceUuid={traceUuid}
                    goodId={good.id}
                    open={graphOpen}
                    onOpenChange={setGraphOpen}
                />
            </div>
        </TooltipProvider>
    );
}
